import React, { useState } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import GeneralInfo from './GeneralInfo';
import PaymentInfo from './PaymentInfo';
import MailTemplateEditor from '../MailTemplateEditor/MailTemplateEditor';

const initialSettings = {
  Title: '',
  Logo: '',
  FavIcon: '',
  PrimaryColor: '#1976d2',
  SecondaryColor: '#dc004e',
  ContactEmail: '',
  ContactPhone: '',
  Address: '',
  SmtpServer: '',
  SmtpPort: '',
  SmtpUseSsl: false,
  SmtpUsername: '',
  SmtpPassword: '',
  SmtpFromEmail: '',
  SmtpFromName: '',
};

const Settings = () => {
  const [settings, setSettings] = useState(initialSettings);
  const [activeTab, setActiveTab] = useState('general');

  const handleSettingsChange = (newSettings) => {
    setSettings(newSettings);
  };

  const handleSave = () => {
    // TODO: Integrate with API to save settings
    alert('Settings saved! (API integration needed)');
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Settings</h3>
      <Tabs activeKey={activeTab} onSelect={setActiveTab} className="mb-3">
        <Tab eventKey="general" title="General Info">
          <GeneralInfo 
            
          />
        </Tab>
        <Tab eventKey="payment" title="Payment Info">
          <PaymentInfo 
            
          />
        </Tab>
        <Tab eventKey="mail" title="Mail Template Editor">
          <MailTemplateEditor />
        </Tab>
      </Tabs>
    </div>
  );
};

export default Settings;
